import { render, staticRenderFns } from "./questions-carousel.vue?vue&type=template&id=ea9cf0c8"
import script from "./questions-carousel.vue?vue&type=script&lang=js"
export * from "./questions-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports